import { fetchApi, fetchPostApi, fetchAction } from "../../../helpers/fetch";


export const testApi = () => fetchApi('/')
export const verifyEmail = (email) => fetchPostApi("/api/auth/verify-email", { email })
export const signUpUser = (obj, user_only) => fetchPostApi(`/api/auth/signup?user_only=${user_only}`, obj)
export const signUpUserV2 = (obj) => fetchPostApi(`/api/auth/signup-v2`, obj)
export const softwallSignupAndLogin = (obj) => fetchPostApi(`/api/auth/softwall-signup-login`, obj)
export const completeSignupPassword = (obj) => fetchPostApi(`/api/auth/complete-signup-password`, obj)
/** @param {string | { email: string, username?: string, is_creator?: boolean }} payload */
export const sendInviteFromSoftwall = (payload) => {
    const body = typeof payload === "string" ? { email: payload } : payload;
    return fetchPostApi("/api/auth/send-invitation-by-email", body);
};

export const login = (obj) => fetchPostApi("/api/auth/login", obj)
export const getUserById = (id) => fetchApi(`/api/profile/${id}?include_creations=true&include_news=true&include_subscribers=true&include_subscriptions=true`)
export const sendInviteFromAdmin = (email) => fetchPostApi("/api/auth/verify-email", { email })
export const getUserOnboardingVersion = () => fetchAction("/api/profile/onboarding-version", [
    'GET_USER_ONBOARDING_VERSION_REQUEST',
    'GET_USER_ONBOARDING_VERSION_SUCCESS',
    'GET_USER_ONBOARDING_VERSION_FAILURE'
])
export const sendResetLink = (email) => fetchPostApi("/api/auth/send-reset", { email })
export const recoverPwd = (password, passwordVerification, email, old_password) => fetchPostApi("/api/auth/recover-pwd", { password, passwordVerification, email, old_password })
export const verifyToken = (token) => fetchPostApi("/api/auth/verify-token", { token })

export const setSessionUser = (session) => {
    return {
        type: 'SET_SESSION',
        payload: session
    }
}

export const setUser = (user) => {
    return {
        type: 'SET_USER',
        payload: user
    }
}

export const updateUser = (fields) => {
    return {
        type: 'UPDATE_USER',
        payload: fields
    }
}

export const setAuthLoading = (value) => {
    return {
        type: 'SET_AUTH_LOADING',
        payload: value
    }
}

export const setUserRole = (role) => {
    return {
        type: 'SET_USER_ROLE',
        payload: role
    }
}